import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from "../../environments/environment";
import { BBResponseContainer } from '../carrier/response-container';
import { timeout, tap, map, catchError } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { AnimalBatch } from '../agptesting-newview/model/animalBatch'
import { ShipToSenderDTO } from './ship-To-Sender';
import { InvoiceExport } from './model/invoice-export';


@Injectable()
export class APGAdministrationService {
  defaultTimeout = 600000;

  constructor(private http: HttpClient) {
  }

  redoBatchService(batch: AnimalBatch): Observable<BBResponseContainer> {
    let url = environment.BB_APG_SAMPLE_PROCESSING_URL + "covid19Batch/redo";
    return this.http.put<BBResponseContainer>(url, batch).pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
      error.url = url;
    }));
  }

  changeBatchStatus(batch: AnimalBatch): Observable<BBResponseContainer> {
    let url = environment.BB_APG_SAMPLE_PROCESSING_URL + "animalBatch/status";
    return this.http.put<BBResponseContainer>(url, batch).pipe(timeout(environment.defaultTimeout));
  }

  getBatchForLabAndBatchId(labId: string, batchId: string): Observable<BBResponseContainer> {
    let url = environment.BB_APG_SAMPLE_PROCESSING_URL + "animalBatch";
    let requestParam = new HttpParams().set('lab', labId).set('batchID', batchId);
    const options = url ? { params: requestParam } : {};
    return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout));
  }
  getSampleInfo(selectedLabId: string, searchID: string): Observable<BBResponseContainer> {
    let url = environment.BB_APG_SAMPLE_PROCESSING_URL + "animalBatch/sample/search?labId=" + selectedLabId + '&sampleId='+ searchID;
    return this.http.get<BBResponseContainer>(url).pipe(timeout(environment.defaultTimeout));
  }

  fetchSampleInfo(selectedLabId: string, searchID: string): Observable<BBResponseContainer> {
    let url = environment.BB_APG_SAMPLE_PROCESSING_URL + "covid19Batch/sample/search/" + selectedLabId + "/" + searchID;
    return this.http.get<BBResponseContainer>(url).pipe(timeout(environment.defaultTimeout));
  }

  deleteSampleFromBatch(selectedLabId: string, sampleBarcode: string, batchIdToDeleteSample: string) {
    let url = environment.BB_APG_SAMPLE_PROCESSING_URL + "covid19Batch/sample/remove?lab=" + selectedLabId + '&sampleBarcode=' + sampleBarcode;
    if (batchIdToDeleteSample)
      url = url + "&batchId=" + batchIdToDeleteSample;
    return this.http.put<BBResponseContainer>(url, '').pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
      error.url = url;
    }));
  }

  removeBatch(labId: string, labName: string, batchId: string) {
    let url = environment.BB_APG_SAMPLE_PROCESSING_URL + "covid19Batch/remove/" + labId + '/' + labName + '/' + batchId;
    return this.http.put<BBResponseContainer>(url, '').pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
      error.url = url;
    }));
  }

  changeFalseRedo(labId: string, animalBatch: AnimalBatch, redoCount: number) {
    let url = environment.BB_APG_SAMPLE_PROCESSING_URL + "covid19Batch/falseredo/" + labId + '/' + redoCount;
    return this.http.put<BBResponseContainer>(url, animalBatch).pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
      error.url = url;
    }));
  }

  removeUnnecessaryRedo(labId: string, selectedBatchIdToComplete: string, batchIdsTobeRemoved: string[]) {
    let url = environment.BB_APG_SAMPLE_PROCESSING_URL + "covid19Batch/unnecessaryredo/" + labId + '/' + selectedBatchIdToComplete;
    return this.http.put<BBResponseContainer>(url, batchIdsTobeRemoved).pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
      error.url = url;
    }));
  }

  shipToSender(shipToSenderDTO: ShipToSenderDTO) {
    let url = environment.BB_APG_SAMPLE_PROCESSING_URL + "covid19Batch/shipToBarcode";
    return this.http.post(url, shipToSenderDTO).pipe(timeout(environment.defaultTimeout), tap(event => {
      /* */
    }, error => {
      error.url = url;
    }));
  }

  submitOrder(request): Observable<BBResponseContainer>{
    let url = environment.BB_ANIMAL_ORDER_SERVICE_URL+"api/shipping";
    return this.http.post<BBResponseContainer>(url, request).pipe(timeout(environment.defaultTimeout), tap(event => {
      /* */
    }, error => {
      error.url = url;
    }));
  }

  submitEvent(request): Observable<BBResponseContainer>{
    let url = environment.BB_ANIMAL_ORDER_SERVICE_URL+"mockEvent/receiveMessage";
    return this.http.post<BBResponseContainer>(url, request).pipe(timeout(environment.defaultTimeout), tap(event => {
      /* */
    }, error => {
      error.url = url;
    }));
  }

  getSampleOrderStatus(id): Observable<BBResponseContainer> {
    let url = environment.BB_ANIMAL_ORDER_SERVICE_URL+"api/shipping/status/order/"+id;
    return this.http.get<BBResponseContainer>(url).pipe(timeout(environment.defaultTimeout), tap(event => {
      /* */
    }, error => {
      error.url = url;
    }));
  }

  fetchDeliveryInfo(deliveryId: string): Observable<BBResponseContainer> {
    let url = environment.BB_ANIMAL_ORDER_SERVICE_URL+"api/invoice/delivery?delivery="+deliveryId
    return this.http.get<BBResponseContainer>(url).pipe(timeout(environment.defaultTimeout), tap(event => {
      /* */
    }, error => {
      error.url = url;
    }));
  }

  fetchInvoicedOrders(fromDate: string, untilDate: string){
    let url = environment.BB_ANIMAL_ORDER_SERVICE_URL+"api/invoice/dateRange?from="+fromDate+"&until="+untilDate;
    return this.http.get<BBResponseContainer>(url).pipe(timeout(environment.defaultTimeout), tap(event => {
      /* */
    }, error => {
      error.url = url;
    }));
  }

  fetchOrder(deliveryId: string, sampleId: string): Observable<BBResponseContainer> {
    let url = environment.BB_ANIMAL_ORDER_SERVICE_URL+"api/shipping/order/"+sampleId+"?delivery="+deliveryId
    return this.http.get<BBResponseContainer>(url).pipe(timeout(environment.defaultTimeout), tap(event => {
      /* */
    }, error => {
      error.url = url;
    }));
  }

  exportInvoice(invoiceExport: InvoiceExport){
    let url = environment.BB_ANIMAL_ORDER_SERVICE_URL+"api/invoice/export";
    return this.http.post(url, invoiceExport, { observe: 'response', responseType: 'blob' }).pipe(
      map((res) => {
        console.log("service class method ", res)
        let data = {
          fileContent: new Blob([res.body], { type: res.headers.get('content-Type') }),
          filename: res.headers.get('filename')
        }
        return data;
      }), catchError(error => Observable.throw(null))
    )
  }
}
